import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output, ViewChild} from "@angular/core";
import {NotificationService} from "@pb-labs/notification";
import {finalize, Subject, takeUntil} from "rxjs";
import {AuthorizationService} from "@app/services/authorization.service";
import {SFTPMainPages} from "@app/modules/models";
import {Router} from "@angular/router";

@Component({
  selector: "app-top-panel",
  templateUrl: "./top-panel.component.html",
  styleUrls: ["./top-panel.component.scss"],
})
export class TopPanelComponent implements OnDestroy {
  @Input() userCornerPopupOpen = false;
  @Input() browseSidebarOpen = false;
  @Input() username: string;
  @Output() userCornerPopupOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>(true);
  @Output() browseSidebarOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() userSettingsSelect: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild("userCornerPopup", {static: false, read: ElementRef}) userCornerPopup: ElementRef;
  @ViewChild("userCornerLink", {static: false, read: ElementRef}) userCornerLink: ElementRef;

  private _destroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private authorizationService: AuthorizationService
  ) {}

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  onUsernameLinkLinkClick(): void {
    this.userCornerPopupOpenChange.emit(!this.userCornerPopupOpen);
  }

  onUserCornerSettings(): void {
    this.userSettingsSelect.emit();
    this.userCornerPopupOpenChange.emit(false);
  }

  onUserCornerLogout(): void {
    this.authorizationService
      .userLogout()
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => {
          this.userCornerPopupOpenChange.emit(false);
        })
      )
      .subscribe({
        next: () => {
          this.router.navigate([`/${SFTPMainPages.login}`]).catch(console.error);
        },
      });
  }

  showBrowseSidebarOpenIcon(): boolean {
    return !this.browseSidebarOpen;
  }

  onBrowseSidebarOpenIconClick(): void {
    this.browseSidebarOpenChange.emit(!this.browseSidebarOpen);
  }

  @HostListener("document:mousedown", ["$event"])
  private onDocumentMouseDown(event: MouseEvent): void {
    if (
      this.userCornerPopupOpen &&
      isOutsideClick(this.userCornerPopup.nativeElement as HTMLElement, this.userCornerLink.nativeElement, event)
    ) {
      this.userCornerPopupOpenChange.emit(false);
    }
  }
}

function isOutsideClick(element: HTMLElement, trigger: HTMLElement, documentClickEvent: MouseEvent): boolean {
  return (
    !element.contains(documentClickEvent.target as Node) &&
    !trigger.contains(documentClickEvent.target as Node) &&
    document.body.contains(documentClickEvent.target as Node)
  );
}
